import React, { Component } from 'react';
import { GoogleApiWrapper } from 'google-maps-react';

import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import GoogleMap from './GoogleMap';
import { GOOGLE_API_KEY } from '../../config';
import mapStyles from '../../configData/maps-style.json';
import { BACKGROUND_LOADER } from '../../globals';


export class MapContainer extends Component {  
  render() {
    const { loaded, google, initCenter, initZoom, centerTo, markers } = this.props;
    if (!loaded) {
      return (
        <LoadingSpinner/>       
      );
    }

    return (     
      <GoogleMap 
        google={google}
        mapStyles={mapStyles}
        initCenter={initCenter}
        initZoom={initZoom}
        centerTo={centerTo}
        markers={markers}
      />
    )
  }
}

export default GoogleApiWrapper({
  apiKey: (GOOGLE_API_KEY),
  language: 'cs'
})(MapContainer)



// WEBPACK FOOTER //
// ./src/common/MapContainer/MapContainer.js